// src/components/Admin/OffersAndBanners/BannerList.js
import React from "react";
import "./Banners.css";

export default function BannerList({
  banners = [],
  onEdit,
  onToggleActive,
  onDelete,
}) {
  const getCampaignInfo = (banner) => {
    if (banner.actionType !== "CAMPAIGN") {
      return null;
    }

    let campaignId = "";
    try {
      const payload = JSON.parse(banner.actionPayload || "{}");
      campaignId = payload.campaignId;
    } catch (e) {
      return null;
    }

    return campaignId;
  };

  if (!banners.length) {
    return (
      <div className="empty-state">
        <h3>No banners created yet</h3>
        <p>Create banners to promote offers on the app.</p>
      </div>
    );
  }

  return (
    <div className="banner-list">
      {banners.map((banner) => (
        <div
          key={banner.id}
          className={`banner-card ${banner.active ? "" : "inactive"}`}
        >
          {/* IMAGE */}
          <div className="banner-image-wrapper">
            <img
              src={banner.imageUrl}
              alt={banner.title}
              className="banner-image"
            />
            {!banner.active && (
              <div className="inactive-badge">Inactive</div>
            )}
          </div>

          {/* INFO */}
          <div className="banner-info">
            <h4 className="banner-title">{banner.title || "—"}</h4>
            <p className="banner-subtitle">
              {banner.subtitle || "No subtitle"}
            </p>

            <div className="banner-meta">
              <span>📍 {banner.placement}</span>
              <span>🏷️ {banner.bannerType}</span>
              <span>⬆ Priority: {banner.priority}</span>
              {banner.actionType === "CAMPAIGN" && getCampaignInfo(banner) && (
                <span>📢 Campaign #{getCampaignInfo(banner)}</span>
              )}
            </div>
          </div>

          {/* ACTIONS */}
          <div className="banner-actions">
            <button
              className="btn-secondary"
              onClick={() => onEdit(banner)}
            >
              ✏️ Edit
            </button>

            <button
              className={banner.active ? "btn-warning" : "btn-success"}
              onClick={() => onToggleActive(banner)}
            >
              {banner.active ? "Deactivate" : "Activate"}
            </button>

            <button
              className="btn-danger"
              onClick={() => onDelete(banner)}
            >
              🗑 Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
